module.exports = __webpack_public_path__ + "img/010024.cca3d393.png";